/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create a definition. This is the only serializer where ``owner`` is writable.
 * 
 * ``WorkflowDef.owner`` is a OneToOneField, so a company holds at most one definition, and
 * ModelSerializer derives the uniqueness validator for that on its own. The field is redeclared
 * below only to replace its default "must be unique" message with an actionable one.
 * @export
 * @interface WorkflowDefCreateRequest
 */
export interface WorkflowDefCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefCreateRequest
     */
    owner?: number | null;
    /**
     * Is this workflow active? Inactive definitions are not used in new workflows.
     * @type {boolean}
     * @memberof WorkflowDefCreateRequest
     */
    isActive?: boolean;
    /**
     * When enabled, events from the same batch that share a grouping field (e.g. site or equipment) will be linked. Configure the linking rule below.
     * @type {boolean}
     * @memberof WorkflowDefCreateRequest
     */
    autoEventLinking?: boolean;
}

/**
 * Check if a given object implements the WorkflowDefCreateRequest interface.
 */
export function instanceOfWorkflowDefCreateRequest(value: object): value is WorkflowDefCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function WorkflowDefCreateRequestFromJSON(json: any): WorkflowDefCreateRequest {
    return WorkflowDefCreateRequestFromJSONTyped(json, false);
}

export function WorkflowDefCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDefCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'autoEventLinking': json['auto_event_linking'] == null ? undefined : json['auto_event_linking'],
    };
}

export function WorkflowDefCreateRequestToJSON(json: any): WorkflowDefCreateRequest {
    return WorkflowDefCreateRequestToJSONTyped(json, false);
}

export function WorkflowDefCreateRequestToJSONTyped(value?: WorkflowDefCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'owner': value['owner'],
        'is_active': value['isActive'],
        'auto_event_linking': value['autoEventLinking'],
    };
}

